export default __webpack_public_path__ + "static/media/destination.54ed1c54.jpg";